import { useEffect } from 'react';
let serverSeo: SeoConfig | null = null;
export function getServerSeo() { return serverSeo; }
export interface SeoConfig { title: string; description: string; keywords?: string; path: string; noindex?: boolean; }
function upsertCanonical(href: string): void {
  let el = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) { el = document.createElement('link'); el.setAttribute('rel', 'canonical'); document.head.appendChild(el); }
  el.setAttribute('href', href);
}
function upsertMeta(attr: string, key: string, content: string): void {
  let el = document.head.querySelector('meta[' + attr + '="' + key + '"]') as HTMLMetaElement | null;
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute('content', content);
}
export function useSeo({ title, description, keywords, path, noindex = false }: SeoConfig): void {
  if (typeof document === 'undefined') serverSeo = { title, description, keywords, path, noindex };
  useEffect(() => {
    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords || '');
    upsertMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow');
    upsertCanonical(path);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', path);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', 'Forex Matrix Lab');
    upsertMeta('name', 'twitter:card', 'summary');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
  }, [title, description, keywords, path, noindex]);
}
